import { createAsyncThunk } from "@reduxjs/toolkit";
import { cancelDeviceSubscription, deleteDevice, deviceDetail, deviceList, devicePayment, deviceSubscribe, regenerateClaimCode, updateDevice } from "./deviceApi";
import { deviceRegister } from "../auth/authApi";


export const deviceListThunk = createAsyncThunk(
    'device/list_devices',
    async (data) => {
        return await deviceList(data);
    }
)

export const updateDeviceThunk = createAsyncThunk(
    'device/update_device',
    async (data) => {
        return await updateDevice(data);
    }
)

export const createDeviceThunk = createAsyncThunk(
    'device/create',
    async (payload) => {
        return await deviceRegister(payload)
    }
)

export const getDeviceDetailThunk = createAsyncThunk(
    'device/detail_device',
    async (payload) => {
        return await deviceDetail(payload)
    }
)
export const devicePaymentThunk = createAsyncThunk(
    'device/payment',
    async (payload) => {
        return await devicePayment(payload)
    }
)

export const deviceSubscribeThunk = createAsyncThunk(
    'device/susbcribe',
    async (data) => {
        return await deviceSubscribe(data);
    }
)

export const cancelDeviceSubsriptionThunk = createAsyncThunk(
    'device/cancel_susbcribe',
    async (data) => {
        return await cancelDeviceSubscription(data);
    }
)

export const regenerateClaimCodeThunk = createAsyncThunk(
    'device/regenerate_claim',
    async (payload) => {
        return await regenerateClaimCode(payload);
    }
)

export const deleteDeviceThunk = createAsyncThunk(
    'device/delete',
    async (payload) => {
        return await deleteDevice(payload);
    }
)
